export default "__VITE_ASSET__BsliGfrO__"